import { NavLink, useLocation } from "react-router-dom";
import pkg from "../../package.json";

const Icon = ({ name }) => {
  const common = {
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  switch (name) {
    case "dashboard":
      return (
        <svg {...common}>
          <rect x="3" y="3" width="7" height="9" />
          <rect x="14" y="3" width="7" height="5" />
          <rect x="14" y="12" width="7" height="9" />
          <rect x="3" y="16" width="7" height="5" />
        </svg>
      );
    case "catalog":
      return (
        <svg {...common}>
          <path d="M20 7L12 3 4 7l8 4 8-4z" />
          <path d="M4 7v10l8 4 8-4V7" />
          <path d="M12 11v10" />
        </svg>
      );
    case "map":
      return (
        <svg {...common}>
          <path d="M1 6v16l7-4 8 4 7-3V1l-7 3-8-3-7 3z" />
          <line x1="7" y1="6" x2="7" y2="20" />
          <line x1="17" y1="2" x2="17" y2="20" />
        </svg>
      );
    case "settings":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3h.1a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8v.1a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
        </svg>
      );
    case "help":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="10" />
          <path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      );
    case "wallet":
      return (
        <svg {...common}>
          <path d="M20 12V8H6a2 2 0 0 1 0-4h12v4" />
          <path d="M4 6v12a2 2 0 0 0 2 2h14v-4" />
          <path d="M18 12a2 2 0 0 0 0 4h4v-4z" />
        </svg>
      );
    case "qr":
      return (
        <svg {...common}>
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
          <line x1="14" y1="14" x2="14" y2="17" />
          <line x1="17" y1="14" x2="17" y2="17" />
          <line x1="14" y1="20" x2="17" y2="20" />
          <line x1="20" y1="14" x2="20" y2="21" />
        </svg>
      );
    default:
      return null;
  }
};

const NAV_ITEMS = [
  { key: "dashboard", label: "Дашборд", icon: "dashboard", to: "/dashboard" },
  { key: "catalog", label: "Каталог", icon: "catalog", to: "/catalog", gapBefore: true },
  { key: "spots", label: "Заведения", icon: "map", to: "/spots" },
  { key: "settings", label: "Настройки", icon: "settings", to: "/settings" },
  {
    key: "billing",
    label: "Биллинг",
    icon: "wallet",
    to: "/billing",
  },
  {
    key: "deferred-uzqr",
    label: "Отложенные UzQR",
    icon: "qr",
    to: "/deferred-uzqr",
  },
  { key: "help", label: "Помощь", icon: "help", to: "/help", gapBefore: true },
];

function CloseIcon({ size = 20 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

function MenuIcon({ size = 20 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <line x1="4" y1="6" x2="20" y2="6" />
      <line x1="4" y1="12" x2="20" y2="12" />
      <line x1="4" y1="18" x2="20" y2="18" />
    </svg>
  );
}

export default function Sidebar({ open = false, onClose, onOpen }) {
  const { pathname } = useLocation();
  return (
    <aside
      className={[
        "appSidebar",
        open ? "appSidebar--open" : "appSidebar--closed",
      ].join(" ")}
    >
      <button
        type="button"
        className="appSidebar__toggle"
        onClick={open ? onClose : onOpen}
        aria-label={open ? "Закрыть меню" : "Открыть меню"}
        aria-expanded={open}
        title={open ? "Закрыть меню" : "Открыть меню"}
      >
        {open ? <CloseIcon /> : <MenuIcon />}
      </button>
      <nav className="appSidebar__nav">
        {NAV_ITEMS.map((item) => {
          return (
            <NavLink
              key={item.key}
              to={item.to}
              title={item.label}
              className={({ isActive }) => {
                const active =
                  item.key === "spots"
                    ? pathname.startsWith("/spots")
                    : item.key === "billing"
                      ? pathname.startsWith("/billing")
                      : isActive;
                return [
                  "appSidebar__item",
                  active ? "active" : "",
                  item.gapBefore ? "appSidebar__item--gap-before" : "",
                ]
                  .filter(Boolean)
                  .join(" ");
              }}
            >
              <span className="appSidebar__icon">
                <Icon name={item.icon} />
              </span>
              <span className="appSidebar__label">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      <div className="appSidebar__footer">
        <div className="appSidebar__version">
          E-POS Poster plugin v{pkg.version}
        </div>
        <div className="appSidebar__copyright">© 2026 E-POS Systems LLC</div>
      </div>
    </aside>
  );
}
